import { orgsRequest } from './request';

const GET_ORG_ID_BY_RAISE_ID_QUERY = `
query Query($raiseId: Int!) {
  orgId(raiseId: $raiseId)
}
`;

export const orgIdByRaiseId = async (
  raiseId: number,
): Promise<string | undefined> => {
  const orgIdByRaiseIdRes = await orgsRequest(GET_ORG_ID_BY_RAISE_ID_QUERY, {
    raiseId,
  });
  const orgIdByRaiseIdResJson = await orgIdByRaiseIdRes.json();
  return orgIdByRaiseIdResJson?.data?.orgId;
};
